var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Breadcrumbs',{attrs:{"current-story":_vm.currentStory}}),_vm._v(" "),(_vm.storyType)?_c(_vm.storyType,{tag:"component",attrs:{"current-story":_vm.currentStory}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }